import React, {useState, useEffect} from 'react';
import {Link, useLocation} from 'react-router-dom';
import SignOutButton from '../SignOut';
import * as ROUTES from '../../constants/routes';
import {AuthUserContext} from '../Session';
import {withFirebase} from '../Firebase';
import SelectSearch, {fuzzySearch} from 'react-select-search';
import './navigation.css'

const Navigation = ({setFakeUid}) => {
    return (
        <div>
            <AuthUserContext.Consumer>
                {(authUser) =>
                    authUser ? <NavigationAuthWithFirebase authUser={authUser} setFakeUid={setFakeUid}/> :
                        <NavigationNonAuth/>
                }
            </AuthUserContext.Consumer>
        </div>
    )
};

const NavigationAuth = ({authUser, firebase, setFakeUid}) => {
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname === path || location.pathname.startsWith(path + '/');
    };

    return (
        <div className="bg-white shadow-nav border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    {/* Logo / Brand */}
                    <div className="flex-shrink-0">
                        <Link
                            to={ROUTES.LANDING}
                            className="text-xl font-bold text-primary-600 hover:text-primary-700 transition-colors no-underline"
                        >
                            Digitalna Kartica
                        </Link>
                    </div>

                    {/* Navigation Links */}
                    <nav className="hidden md:flex items-center space-x-1">
                        <Link
                            to={ROUTES.DASHBOARD}
                            className={`nav-link no-underline ${isActive(ROUTES.DASHBOARD) ? 'nav-link-active' : ''}`}
                        >
                            <span className="flex items-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                                </svg>
                                Dashboard
                            </span>
                        </Link>
                        <Link
                            to={ROUTES.ALERTS}
                            className={`nav-link no-underline ${isActive(ROUTES.ALERTS) ? 'nav-link-active' : ''}`}
                        >
                            <span className="flex items-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                                </svg>
                                Alerts
                            </span>
                        </Link>
                        <Link
                            to={ROUTES.REPORTS}
                            className={`nav-link no-underline ${isActive(ROUTES.REPORTS) ? 'nav-link-active' : ''}`}
                        >
                            <span className="flex items-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                Reports
                            </span>
                        </Link>
                        <Link
                            to={ROUTES.PROFILE}
                            className={`nav-link no-underline ${isActive(ROUTES.PROFILE) ? 'nav-link-active' : ''}`}
                        >
                            <span className="flex items-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                                Profile
                            </span>
                        </Link>
                        <Link
                            to={ROUTES.AI_ADVISOR}
                            className={`nav-link no-underline ${isActive(ROUTES.AI_ADVISOR) ? 'nav-link-active' : ''}`}
                        >
                            <span className="flex items-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                                </svg>
                                AI Savetnik
                            </span>
                        </Link>
                        <Link
                            to={ROUTES.AI_KNOWLEDGE_BASE}
                            className={`nav-link no-underline ${isActive(ROUTES.AI_KNOWLEDGE_BASE) ? 'nav-link-active' : ''}`}
                        >
                            <span className="flex items-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                                </svg>
                                AI Baza Znanja
                            </span>
                        </Link>
                        {/*<AdminLink authUser={authUser} />*/}
                    </nav>

                    {/* Sign Out Button */}
                    <div className="flex items-center">
                        <SignOutButton />
                    </div>
                </div>
            </div>

            {/* Admin Pet Shop Selector */}
            <SelectPetShop authUser={authUser} firebase={firebase} setFakeUid={setFakeUid}/>
        </div>
    )
};

const AdminLink = ({authUser}) => {
    const location = useLocation();
    const isActive = location.pathname === ROUTES.ADMIN;

    if (authUser.uid === "1Rp46TPvHCfEJaddNPqnAL7DTHm1") {
        return (
            <Link
                to={ROUTES.ADMIN}
                className={`nav-link no-underline ${isActive ? 'nav-link-active' : ''}`}
            >
                <span className="flex items-center gap-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    Admin
                </span>
            </Link>
        )
    }
    return null;
}

const SelectPetShop = ({authUser, firebase, setFakeUid}) => {
    const [petShopList, setPetShopList] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        if (authUser.uid === "1Rp46TPvHCfEJaddNPqnAL7DTHm1") {
            console.log("fetch pet shop list")
            firebase.activeCompanies().get().then((querySnapshot) => {
                let companyList = [];
                let petShopList = [];
                querySnapshot.forEach((doc) => {
                    companyList.push({name: doc.data().name, value: doc.data().uid})
                    if (doc.data().billOptionsType === "petShop") {
                        petShopList.push({name: doc.data().name, value: doc.data().uid})
                    }
                });
                const companyListSorted =
                    companyList.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
                const petShopListSorted =
                    petShopList.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
                let firstClearElement = {name: "Clear", value: "Clear"}
                setCompanyList([firstClearElement].concat(companyListSorted))
                setPetShopList([firstClearElement].concat(petShopListSorted))
            }).catch((error) => {
                console.log("Error getting documents: ", error);
            });
        } else {
            setCompanyList([])
            setPetShopList([])
            setFakeUid(null)
            setSelected(null)
        }
    }, []);

    const onSelectChange = (uid) => {
        if (uid === "Clear") {
            setFakeUid(null);
            setSelected(null);
        } else if (uid) {
            setFakeUid(uid);
            setSelected(uid);
        }
    }

    const renderFontOption = (props, {stack, name}, snapshot, className) => {
        if (name === "Clear") {
            return (
                <button {...props} className={className} type="button">
                    <span style={{fontFamily: stack}}><i>{name}</i></span>
                </button>
            );
        }
        return (
            <button {...props} className={className} type="button">
                <span style={{fontFamily: stack}}>{name}</span>
            </button>
        );
    }

    if (authUser.uid === "1Rp46TPvHCfEJaddNPqnAL7DTHm1") {
        return (
            <div className="bg-gray-50 border-t border-gray-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
                    <div className="flex flex-wrap items-center gap-4">
                        <span className="text-sm font-medium text-gray-500">Admin View:</span>
                        <div className="flex gap-3">
                            <SelectSearch
                                value={selected}
                                renderOption={renderFontOption}
                                options={companyList}
                                onChange={onSelectChange}
                                search
                                filterOptions={fuzzySearch}
                                emptyMessage="Not found"
                                placeholder="Select Company"
                            />
                            <SelectSearch
                                value={selected}
                                renderOption={renderFontOption}
                                options={petShopList}
                                onChange={onSelectChange}
                                search
                                filterOptions={fuzzySearch}
                                emptyMessage="Not found"
                                placeholder="Select Pet Shop"
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return null;
}

const NavigationNonAuth = () => {
    return (
        <div className="bg-white shadow-nav border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    <Link
                        to={ROUTES.LANDING}
                        className="text-xl font-bold text-primary-600 hover:text-primary-700 transition-colors no-underline"
                    >
                        Digitalna Kartica
                    </Link>
                    <div className="flex items-center gap-4">
                        <Link
                            to={ROUTES.DOCS}
                            className="text-gray-600 hover:text-gray-900 transition-colors no-underline"
                        >
                            Dokumentacija
                        </Link>
                        <Link
                            to={ROUTES.SIGN_IN}
                            className="btn btn-primary no-underline"
                        >
                            Sign In
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

const NavigationAuthWithFirebase = withFirebase(NavigationAuth);

export default Navigation;
